export * from './product-coupon-assignment-from.component';
